import { shuffle } from '@elgatoylacaja/utils'

export interface SituationSimple {
  id: string
  name: string
  text: string[]
  question: string
  emotionalityQuestion:
    | 'personalEmotionalityQuestion'
    | 'entityEmotionalityQuestion'
  type: 'simple'
}

export interface SituationCompuesto {
  id: string
  name: string
  versions: { id: string; text: string; question: string }[]
  emotionalityQuestion:
    | 'personalEmotionalityQuestion'
    | 'entityEmotionalityQuestion'
  type: 'compuesto'
  text: string[]
}

export type Situation = SituationSimple | SituationCompuesto

export const situations_obligatorios: Situation[] = [
  {
    id: '1',
    name: 'COMITÉ',
    text: ['situation1_1'],
    type: 'compuesto',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    versions: [
      {
        id: '1_1',
        question: 'situation1_1_question',
        text: 'situation1_v1',
      },
      {
        id: '1_2',
        question: 'situation1_2_question',
        text: 'situation1_v2',
      },
      {
        id: '1_3',
        question: 'situation1_3_question',
        text: 'situation1_v3',
      },
    ],
  },
  {
    id: '2',
    name: 'BIG-BRO',
    type: 'simple',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    text: ['situation2_1', 'situation2_2'],
    question: 'situation2_question',
  },
  {
    id: '3',
    name: 'LIBERTADES',
    text: ['situation3_1'],
    type: 'compuesto',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    versions: [
      {
        id: '3_1',
        question: 'situation3_1_question',
        text: 'situation3_v1',
      },
      {
        id: '3_2',
        question: 'situation3_2_question',
        text: 'situation3_v2',
      },
      {
        id: '3_3',
        question: 'situation3_3_question',
        text: 'situation3_v3',
      },
    ],
  },
  {
    id: '4',
    name: 'BUCHONEO',
    type: 'simple',
    emotionalityQuestion: 'personalEmotionalityQuestion',
    text: ['situation4_1', 'situation4_2'],
    question: 'situation4_question',
  },
  {
    id: '5',
    name: 'ANIMALES',
    type: 'simple',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    text: ['situation5_1', 'situation5_2'],
    question: 'situation5_question',
  },
]

export const situations_tren: Situation[] = [
  {
    id: '9',
    name: '',
    type: 'simple',
    emotionalityQuestion: 'personalEmotionalityQuestion',

    text: ['situation9_1', 'situation9_2'],
    question: 'situation9_question',
  },
  {
    id: '10',
    name: '',
    type: 'simple',
    emotionalityQuestion: 'personalEmotionalityQuestion',
    text: ['situation10_1', 'situation10_2'],
    question: 'situation10_question',
  },
]

export const situations_opcionales: Situation[] = [
  {
    id: '6',
    name: 'DETENCIONES',
    type: 'simple',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    text: ['situation6_1'],
    question: 'situation6_question',
  },
  {
    id: '7',
    name: 'KITS',
    type: 'simple',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    text: ['situation7_1', 'situation7_2'],
    question: 'situation7_question',
  },
  {
    id: '8',
    name: 'EXPORTS',
    type: 'simple',
    emotionalityQuestion: 'entityEmotionalityQuestion',
    text: ['situation8_1', 'situation8_2'],
    question: 'situation8_question',
  },
]

export const SITUATIONS: Situation[] = [
  ...situations_obligatorios,
  ...situations_opcionales,
  ...situations_tren,
]

export const getRandom = () => {
  const fork_tren = situations_tren[Math.floor((Math.random() * 10) % 2)]
  const fork_orden = Math.floor((Math.random() * 10) % 2)
  const obligatorios = shuffle(situations_obligatorios)
  const opcionales = shuffle(situations_opcionales)

  const situations_obligatorios_user =
    fork_orden === 0
      ? [fork_tren, ...obligatorios]
      : [...obligatorios, fork_tren]

  return {
    situations_obligatorios: situations_obligatorios_user,
    situations_opcionales: opcionales,
    orden: [...situations_obligatorios_user, ...opcionales].map(_ => _.id),
    config: {
      fork_tren: fork_tren.id === '9' ? 'palanca' : 'persona',
      fork_orden: fork_orden === 0 ? 'tren primero' : 'tren al final',
      orden_obligatorios: obligatorios.map(_ => `${_.id} ${_.name}`),
      orden_opcionales: opcionales.map(_ => `${_.id} ${_.name}`),
    },
  }
}
